import { ExpandableSection, ExpandableSectionProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../domain'
import { useConditionalCovers, useIncludedCovers } from '../../../hooks/covers'
import { getExposuresContentBaseUrl, useConfig } from '../../../state/configuration'
import { useProduct } from '../../product/productContext'
import { ConditionalCoverItem } from './ConditionalCoverItem'
import { CoverEndorsements } from './CoverEndorsements'
import { IncludedCoverItem } from './IncludedCoverItem'

export interface IncludedCoversExpandableProps extends ExpandableSectionProps {
  quote: Quote
}

export const IncludedCoversExpandable: FunctionComponent<
  IncludedCoversExpandableProps
> = ({ quote, header, ...props }) => {
  const { scheme, product } = useProduct()

  const includedCovers = useIncludedCovers(product)
  const conditionalCovers = useConditionalCovers(quote, product)
  const contentBaseUrl = useConfig(getExposuresContentBaseUrl(scheme.schemeCode))

  return (
    <ExpandableSection header={header} {...props}>
      {includedCovers.map((it) => (
        <IncludedCoverItem
          key={it}
          cover={it}
          width={1}
          contentBaseUrl={contentBaseUrl}
          typoSize='sm'
          iconSize='small'
        />
      ))}
      {conditionalCovers.map((it) => (
        <ConditionalCoverItem
          key={it.coverCode}
          conditionalCover={it}
          width={1}
          typoSize='sm'
          iconSize='small'
        />
      ))}
      <CoverEndorsements quote={quote} my={3} />
    </ExpandableSection>
  )
}
